import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from '@denishussar/html5-game-engine';
import {AnimationContents} from '../../../../AnimationContents';
import {GameLogic} from '../../../Logic/GameLogic';
import {RescueLogic} from '../../../Logic/MiniGames/RescueLogic';
import {SpineAnimationBaseController} from '../../Spine/SpineAnimationBaseController';
import {Graphics, Rectangle} from 'pixi.js';
import {RescueModel} from '../../../Models/MiniGames/RescueModel';
import {ButtonController} from "../../../Common/ButtonController";


export interface ISliderControllerOptions {
    onComplete: () => void;
}

export class SliderController extends AnimationBaseController {
    public $model: RescueModel;

    public constructor(@Inject private _options: ISliderControllerOptions,
                       @Inject private _rescueLogic: RescueLogic
    ) {
        super('SliderController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
            },
            modelWatch: {
                sliderValue: (value: number) => {
                    this.y = (240 -value * 240);
                },
            },
        };
    }

    protected onInitialize(): void {
    }
}
